import { render, staticRenderFns } from "./TeamAdminDashboard.vue?vue&type=template&id=16f698fe&"
import script from "./TeamAdminDashboard.vue?vue&type=script&lang=ts&"
export * from "./TeamAdminDashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports